

const RewardType = {
  SpendReward: "SpendReward",
  InviteFriendReward: "InviteFriendReward",
  ProductPurchaseReward: "ProductPurchaseReward",
  SubscriptionDurationReward: "SubscriptionDurationReward",
  VenueVisitReward: "VenueVisitReward",
}

function getRecurrenceTypeTitle(isRecurring){
    return isRecurring ? 'Recurring' : "One-Off"
}

function getRewardTypeTitle(rewardType){
     switch(rewardType)  {
      case RewardType.SpendReward: 
      return "Spending";
      case RewardType.InviteFriendReward:
        return "Invites"
      case RewardType.ProductPurchaseReward:
        return "Product Purchase"
      case RewardType.SubscriptionDurationReward:
        return "Subscription Duration"
      case RewardType.VenueVisitReward:
        return "Venue Visit"
        default: 
        return "Unknown"

    }
}

function getExpirationDateTitle(date){

  return new Date(date)?.toLocaleDateString("da-DK") ?? date;
}

function getRewardTypeTargetValue(reward){
    switch(reward.rewardType)  {
        case RewardType.SpendReward: 
        return reward?.amountTarget + " kr.";
        case RewardType.InviteFriendReward:
        return reward?.numberOfFriendsToInvite + " friends";
        case RewardType.ProductPurchaseReward:
        return reward?.targetQuantity + " products";
        case RewardType.SubscriptionDurationReward:
        return reward?.targetNumberOfDays + " days";
        case RewardType.VenueVisitReward:
        return reward?.allowedVenueIds.length + " venue(s)";
        default: 
        return "Unknown"

    }
  }
  


export {getRecurrenceTypeTitle, getRewardTypeTitle, getExpirationDateTitle, getRewardTypeTargetValue, RewardType}